/**
 * Design-system breakpoints. CSS `@media` widths in `client/index.css` and
 * Tailwind `md` / `lg` in `client/tailwind.config.ts` must stay on these values.
 *
 * Phone and below-desktop queries are `max-width: N − 1` so they meet the
 * Tailwind `min-width` utilities without a 1px gap or overlap.
 */
export const BREAKPOINTS = {
  phoneMaxPx: 767,
  tabletMinPx: 768,
  tabletMaxPx: 1023,
  desktopMinPx: 1024,
} as const;

export const PHONE_MEDIA = `(max-width: ${BREAKPOINTS.phoneMaxPx}px)`;
export const BELOW_DESKTOP_MEDIA = `(max-width: ${BREAKPOINTS.tabletMaxPx}px)`;
export const DESKTOP_MEDIA = `(min-width: ${BREAKPOINTS.desktopMinPx}px)`;
